import React from "react";
import { FormGroup, Label, Input, Col } from "reactstrap";
import { connect } from "react-redux";
import Section from "../../components/Section";
import { updateField } from "../../../redux/actions/configActions";

const mapDispatchToProps = { updateField };
const mapStateToProps = state => {
  const { configReducer } = state;
  return {
    config: configReducer.config,
    files: configReducer.files
  };
};

class GameSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gameimages: [0]
  }
    // #region event binders
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.Delete_winnerImage = this.Delete_winnerImage.bind(this);
    this.Add_winnerImage=this.Add_winnerImage.bind(this);
    // #endregion
  }
  // #region events

  handleChange(event) {
    //alert(event.target.name);
    this.props.updateField({ [event.target.name]: event.target.value });
  }

  handleCheckboxChange(event) {
    event.persist();
    const { config } = this.props;
    this.props.updateField({
      [event.target.name]: !config[event.target.name]
    });
  }
  Delete_winnerImage(event){
     this.props.updateField({ [event.target.id]:-1 });
  }
    Add_winnerImage(event)
    {
      var img =document.getElementById("new_winner").value;
      this.props.updateField({
        [event.target.id]:img
      });
      document.getElementById("new_winner").value =null;
    }

  // #endregion
  render() {
    const { config } = this.props;
    console.log('Gamesetting');
    console.log(config);
    var compteur = 1;
    const items = [];
    var loding=true;
    while(loding)
    {
      var imagegagnat = config["imagegagnante"+compteur] ;
      if(imagegagnat==null){
        loding=false;
      }
      else
      {
        if(imagegagnat!=-1)
        {
          items.push(compteur);
        }
        console.log(imagegagnat);     
        console.log(items);       
        compteur++;
      }
    }
    const gamable = (config.Game && config.setting==1 )? (
      <Input
        checked
        type="checkbox"
        name="Game"
        id="Game"
        onChange={this.handleCheckboxChange}
      />
    ) : (
      <Input
        type="checkbox"
        name="Game"
        id="Game"
        onChange={this.handleCheckboxChange}
      />
    );
    const AddImageGame =config.Game ? (<form>
      <FormGroup row className="d-flex justify-content-center">
        <label className="ml-5" sm={2}> Add new winner </label>
        <input 
              type="number" 
              id="new_winner"
              name="new_winner"
              className="ml-2"
              sm={2}/>
              &nbsp;&nbsp;
       <input 
              type="button" 
              value="Add"
              id={'imagegagnante'+(items.length+1)}
              onClick={this.Add_winnerImage}
              className="ml-2"
              sm={2}/>
              &nbsp;&nbsp;
      </FormGroup>
</form>):null;
    const gameImages =
    ( config.Game && config.setting==1) ? (
      
      items.map(index =>(
    
      <form>
                <FormGroup row className="d-flex justify-content-center">
                  <label className="ml-5" sm={3}>{'Image winner ' +index }</label>
                  <input 
                        type="number" 
                        value={config['imagegagnante'+index]} 
                        name={'imagegagnante'+index}
                        onChange={this.handleChange}
                        className="ml-2"
                        sm={2}/>
                 {index== items.length ? (<input 
                        type="button" 
                        value="Delete" 
                        id={'imagegagnante'+index}
                        onClick={this.Delete_winnerImage}
                        className="ml-2"
                        sm={2}/>) :<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                 }
                </FormGroup>
     </form>))) : null;

    return (
      <Section title="Game settings">
        <FormGroup row className="d-flex justify-content-center">
        <Label  className="ml-2" sm={2}>
            <Col>       
             {gamable}Activate  
             </Col>               
          </Label>
          
        </FormGroup>
        {AddImageGame}
        {gameImages} 
       
      </Section>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GameSettings);



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/GameSettings.jsx